import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-ui-button',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})
export class UiButtonComponent {
    /** Texte affiché dans le bouton */
    @Input() label: string = 'Confirmer';

    /** Type HTML natif */
    @Input() type: 'button' | 'submit' | 'reset' = 'button';

    /** Variante visuelle */
    @Input() variant: 'primary' | 'secondary' | 'danger' | 'outline' | 'ghost' | 'success' = 'primary';

    /** Taille */
    @Input() size: 'xs' | 'sm' | 'md' | 'lg' = 'md';

    /** Icône Material Icons à gauche du label */
    @Input() iconLeft?: string;

    /** Icône Material Icons à droite du label */
    @Input() iconRight?: string;

    /** Bouton carré avec une seule icône (pas de label affiché) */
    @Input() iconOnly?: string;

    /** Classe CSS personnalisée pour l'icône (ex: "fa fa-user" pour FontAwesome) */
    @Input() iconLeftClass?: string;

    /** Classe CSS personnalisée pour l'icône droite */
    @Input() iconRightClass?: string;

    /** Affiche le spinner de chargement */
    @Input() loading: boolean = false;

    /** Désactive le bouton */
    @Input() disabled: boolean = false;

    /** Prend toute la largeur du conteneur */
    @Input() fullWidth: boolean = false;

    /** Tooltip aria-label */
    @Input() ariaLabel?: string;

    @Output() clicked = new EventEmitter<void>();

    get classes(): string[] {
        return [
            'btn',
            `btn-${this.variant}`,
            `btn-${this.size}`,
            this.fullWidth ? 'btn-full' : '',
            this.iconOnly ? 'btn-icon-only' : '',
        ].filter(Boolean);
    }

    onClick(): void {
        if (!this.disabled && !this.loading) {
            this.clicked.emit();
        }
    }
}